
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenWorkflowStatus {
    static readonly Potential: GenWorkflowStatus = new GenWorkflowStatus('Potential');
    static readonly InQueue: GenWorkflowStatus = new GenWorkflowStatus('InQueue');
    static readonly OnHold: GenWorkflowStatus = new GenWorkflowStatus('OnHold');
    static readonly InProgress: GenWorkflowStatus = new GenWorkflowStatus('InProgress');
    static readonly Uploading: GenWorkflowStatus = new GenWorkflowStatus('Uploading');
    static readonly Review: GenWorkflowStatus = new GenWorkflowStatus('Review');
    static readonly Complete: GenWorkflowStatus = new GenWorkflowStatus('Complete');
    static readonly Error: GenWorkflowStatus = new GenWorkflowStatus('Error');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'Potential') return GenWorkflowStatus.Potential;
        if (name === 'InQueue') return GenWorkflowStatus.InQueue;
        if (name === 'OnHold') return GenWorkflowStatus.OnHold;
        if (name === 'InProgress') return GenWorkflowStatus.InProgress;
        if (name === 'Uploading') return GenWorkflowStatus.Uploading;
        if (name === 'Review') return GenWorkflowStatus.Review;
        if (name === 'Complete') return GenWorkflowStatus.Complete;
        if (name === 'Error') return GenWorkflowStatus.Error;
        throw new Error('Unexpected value for GenWorkflowStatus:' + name);
    }

    static values(): GenWorkflowStatus[] {
        return [
            GenWorkflowStatus.Potential,
            GenWorkflowStatus.InQueue,
            GenWorkflowStatus.OnHold,
            GenWorkflowStatus.InProgress,
            GenWorkflowStatus.Uploading,
            GenWorkflowStatus.Review,
            GenWorkflowStatus.Complete,
            GenWorkflowStatus.Error,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

